<div class="modal-content">
  <div class="modal-header">
    <h3>Resumen en video - informe {{Ultimoperiodo | formatPeriodoInformePensiones}}</h3>
    <div class="iconoCerrar">
      <ion-icon role="button" tabindex="0" aria-label="Cerrar" (click)="iconoCerrar()" class="icon i-close" (keydown.enter)="iconoCerrar()"></ion-icon>
    </div>
  </div>

  <div class="video-wrapper">
    <div class="video-loader">
      <div class="spinner"></div>
    </div>
    
    <div id="individeo-player-container"></div>
  </div>
</div>